import { DeviceProvider } from "@/react/components/shared/BuilderUI/DeviceProvider";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { Preview } from "./Preview";

export interface StorePreviewProps {
  shouldShowBlockHover?: boolean;
}

export const StorePreview = ({
  shouldShowBlockHover = true,
}: StorePreviewProps) => {
  // Single subscription for all preview data
  const { blocks, components, canvasSize } = useBuilderStore(state => ({
    blocks: state.getBlocks(),
    components: state.getBlockRenderers(),
    canvasSize: state.canvasSize,
  }));

  return (
    <DeviceProvider isPreviewMode canvasSize={canvasSize}>
      <Preview
        block={blocks}
        components={components}
        path="blocks"
        shouldShowBlockHover={shouldShowBlockHover}
      />
    </DeviceProvider>
  );
};
